<template>
	<div style="padding: 0px;">
		<div>
			<div style="min-width: 120px;float: right;margin-right: 20px;">
				<el-button type="primary" icon="el-icon-plus" @click="addLocDevcie">添加</el-button>
			</div>
		</div>
		<div style="margin-top: 10px;">
			<el-table :data="sysLocPointsList"  style="width: 100%"  max-height="500">
				<el-table-column prop="devname" label="设备名称" align="center"></el-table-column>
			    <el-table-column prop="devcode" label="设备编码" align="center"></el-table-column>
				<el-table-column prop="devtype" label="设备类型" align="center"></el-table-column>
				<el-table-column prop="devmodel" label="设备型号" align="center"></el-table-column>
				<el-table-column fixed="right" prop="op" label="操作" width="180" align="center">
					<template slot-scope="scope">
						<a @click="deleteLocPoint(scope.$index, scope.row)" title="删除" style="display:inline-block;cursor:pointer;color: #F56C6C;margin-left: 20px;">
							<i class="el-icon-Stall">删除</i>
						</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div style="text-align: center;">
			<el-pagination background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]" :current-page="param.page"
				:page-size="param.pagenum" :total="locPointTotal" @size-change="handleSizeChange" @current-change="handleCurrentChange"> </el-pagination>
		</div>
		<el-dialog @close="refrashRelData" append-to-body :destroy-on-close="true" title="添加关联设备" width="70%" :visible.sync="addrelshow">
			<AddLocDevice @needRelRefrash="needRelRefrash" :add="true" :selectedloc="syslocinfo" ></AddLocDevice>
		</el-dialog>
	</div>
</template>

<script> 
	import { queryLocRealDev, deleteLocRealDev } from '/static/apiUrl.js'
	import AddLocDevice from './addlocdev'
	export default {
		name : 'LocDev',
		data() {
			return {
				syslocinfo : {
					id: "",
					name: "",
					parentid : '',
					orgid: "",
					typeid: "",
					idx : 0
				},
				param : {
					page : 1,
					pagenum : 10,
				},
				locPointTotal : 0,
				sysLocPointsList : [],
				addrelshow : false,
				devtypeList : [
					{ id : 'air-out', name: '空调外机'},
					{ id : 'air-in', name: '空调内机'}
				],
				devmodelList : [
					{ id: 'power', name: '电表' },
					{ id: 'mdv4', name: '美的V4' },
					{ id: 'mdv6', name: '美的V6' },
					{ id: 'mdv8', name: '美的V8' },
				],
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		components: {
			AddLocDevice,
		},
		props: {
			selectedloc: {
				type: Object,
				required: true
			},
		},
		watch: {
			selectedloc: {
				immediate: true,
				handler(newVal) {
					if(newVal != null){
						this.syslocinfo.id = newVal.id
						this.syslocinfo.name = newVal.name
						this.syslocinfo.parentid = newVal.parentid
						this.syslocinfo.orgid = newVal.orgid
						this.syslocinfo.typeid = newVal.typeid
						this.syslocinfo.idx = newVal.idx
						this.queryLocPointList()
					}else{
						this.syslocinfo.id = ""
						this.syslocinfo.name = ""
						this.syslocinfo.parentid = ""
						this.syslocinfo.orgid = ""
						this.syslocinfo.typeid = ""
						this.syslocinfo.idx = 0
					}
				}
			},
		},
		methods: {
			initData(){
				
			},
			handleSizeChange(val){
				this.param.pagenum = val;
				this.queryLocPointList()
			},
			handleCurrentChange(val){
				this.param.page = val
				this.queryLocPointList()
			},
			queryLocPointList(){
				this.sysLocPointsList = []
				queryLocRealDev({
					locid : this.syslocinfo.id,
					pagenum : this.param.page ,
					pagesize : this.param.pagenum
				}).then(res => {
					if(0 == res.code){
						this.locPointTotal = res.datas.totalnum
						res.datas.data.forEach((set) => {
							let type = set.devtype
							this.devtypeList.forEach((item) => {
								if(item.id == set.devtype){
									type = item.name
								}
							})
							let model = set.devmodel
							this.devmodelList.forEach((item) => {
								if(item.id == set.devmodel){
									model = item.name
								}
							})
							this.sysLocPointsList.push({
								id: set.id,
								devname: set.devname,
								devid: set.devid,
								devcode : set.devcode,
								devmodel : model,
								devtype : type
							})
						})
					}
				})
			},
			deleteLocPoint(idx,row){
				this.$confirm('此操作将删除位置绑定的设备 '+this.sysLocPointsList[idx].devname+', 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteLocRealDev({
						id : this.sysLocPointsList[idx].id
					}).then(res => {
						if(0 == res.code){
							this.queryLocPointList()
							this.$message({
								showClose: true,
								message: "删除成功",
								type: 'success'
							});
						}else{
							this.$message({
								showClose: true,
								message: res.message,
								type: 'error'
							});
						}
					})
				}).catch(() => {
					console.log("取消")
				});
			},
			addLocDevcie(){
				this.addrelshow = true
			},
			needRelRefrash(val,isshow){
				this.editok = val
				this.addrelshow = isshow
			},
			refrashRelData() {
				if(this.editok){
					this.queryLocPointList()
				}
			},
			
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>